import ScheduleEntity from "./ScheduleEntity";
import UserEntity from "./UserEntity";

export default class StablishmentEntity {
    id: string;
    name: string;
    address: string;
    phone: string;
    type: string;
    email: string;
    managerName?: string;
    supervisor?: UserEntity;
    latitude?: number;
    longitude?: number;
    schedules: ScheduleEntity[];

    constructor(init?: Partial<StablishmentEntity>) {
        this.id = init?.id ?? "";
        this.name = init?.name ?? "";
        this.address = init?.address ?? "";
        this.phone = init?.phone ?? "";
        this.type = init?.type ?? "";
        this.email = init?.email ?? "";
        this.managerName = init?.managerName;
        this.supervisor = init?.supervisor;
        this.latitude = init?.latitude ?? 0;
        this.longitude = init?.longitude ?? 0;
        this.schedules = init?.schedules ?? [];
    }

    static empty(): StablishmentEntity {
        return new StablishmentEntity();
    }
}
